import { services } from '@tomtom-international/web-sdk-services';

import { GenericPrediction } from 'components/autocomplete-address-input/types';
import { IAddressPredictions } from 'pages/store-locator/context/types';
import { useFlag } from 'state/launchdarkly';
import { useStoreContext } from 'state/store';
import { getApiKey } from 'utils/environment';
import { LaunchDarklyFlag } from 'utils/launchdarkly';
import { logger } from 'utils/logger';

import { addressPredictionMapper } from './mappers/addressPredictionMapper';
import { genericPredictionMapper } from './mappers/genericPredictionMapper';
import { useCountryStoreRestrictions } from './use-country-store-restriction';

export const useAddressTomTomPredictions = () => {
  const { getCountryStoreRestriction } = useCountryStoreRestrictions();
  const { setStoreAddresses } = useStoreContext();
  const enableMapFallBack = useFlag(LaunchDarklyFlag.ENABLE_MAP_FALLBACK);

  const getPredictions = async (location: string) => {
    if (enableMapFallBack && location) {
      try {
        const { results } = await services.fuzzySearch({
          key: getApiKey('tomtom'),
          query: location,
          countrySet: getCountryStoreRestriction(),
        });

        const newPredictions: GenericPrediction[] = results?.map(genericPredictionMapper) || [];

        const addressPredictions: IAddressPredictions[] =
          results?.map(addressPredictionMapper) || [];
        setStoreAddresses(addressPredictions);
        return newPredictions;
      } catch {
        logger.warn({ message: 'Error getting predictions' });
      }
    }
    return [];
  };

  return { getPredictions };
};
